import React, { useMemo, useState } from "react";
import "./App.css";
import Home from "./pages/Home";
import users from "./env/users.json";

function App() {
  const [employeeId, setEmployeeId] = useState("");
  const [passcode, setPasscode] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loggedInUser, setLoggedInUser] = useState(null);

  const normalizedUsers = useMemo(() => {
    if (!Array.isArray(users)) {
      return [];
    }

    return users.map((user) => ({
      employee_id: String(user.employee_id || "").trim().toLowerCase(),
      passcode: String(user.passcode || "").trim(),
      last_name: String(user.last_name || "").trim().toLowerCase(),
      first_name: String(user.first_name || "").trim(),
      role: String(user.role || "employee").trim(),
    }));
  }, []);

  const handleLogin = (event) => {
    event.preventDefault();

    const normalizedEmployeeId = employeeId.trim().toLowerCase();
    const normalizedPasscode = passcode.trim();
    const normalizedLastName = lastName.trim().toLowerCase();

    if (!normalizedEmployeeId || !normalizedPasscode || !normalizedLastName) {
      setErrorMessage("Employee ID, passcode, and last name are required.");
      return;
    }

    const matchedUser = normalizedUsers.find((user) => {
      return (
        user.employee_id === normalizedEmployeeId &&
        user.passcode === normalizedPasscode &&
        user.last_name === normalizedLastName
      );
    });

    if (!matchedUser) {
      setErrorMessage("Login failed. Check employee ID, passcode, and last name exactly as stored in users.json.");
      return;
    }

    setErrorMessage("");
    setLoggedInUser(matchedUser);
  };

  const handleLogout = () => {
    setLoggedInUser(null);
    setEmployeeId("");
    setPasscode("");
    setLastName("");
    setErrorMessage("");
  };

  if (loggedInUser) {
    return <Home loggedInUser={loggedInUser} onLogout={handleLogout} />;
  }

  return (
    <div className="app-login-shell">
      <div className="app-login-background" />

      <div className="app-login-panel">
        <div className="app-login-badge">Graystone Marketing Team</div>
        <h1 className="app-login-title">Employee Access Portal</h1>
        <p className="app-login-copy">
          Sign in with employee ID, passcode, and last name to continue into the field operations dashboard.
        </p>

        <form className="app-login-form" onSubmit={handleLogin}>
          <div className="app-login-field">
            <label htmlFor="employeeId" className="app-login-label">
              Employee ID #
            </label>
            <input
              id="employeeId"
              className="app-login-input"
              type="text"
              value={employeeId}
              onChange={(event) => setEmployeeId(event.target.value)}
              placeholder="Enter employee ID"
            />
          </div>

          <div className="app-login-field">
            <label htmlFor="passcode" className="app-login-label">
              Employee Passcode
            </label>
            <input
              id="passcode"
              className="app-login-input"
              type="password"
              value={passcode}
              onChange={(event) => setPasscode(event.target.value)}
              placeholder="Enter passcode"
            />
          </div>

          <div className="app-login-field">
            <label htmlFor="lastName" className="app-login-label">
              Employee Last Name
            </label>
            <input
              id="lastName"
              className="app-login-input"
              type="text"
              value={lastName}
              onChange={(event) => setLastName(event.target.value)}
              placeholder="Enter last name"
            />
          </div>

          {errorMessage ? <div className="app-login-error">{errorMessage}</div> : null}

          <button type="submit" className="app-login-button">
            Sign In
          </button>
        </form>

        <div className="app-login-note">
          <div>Expected file format for <code>src/env/users.json</code>:</div>
          <pre className="app-login-json-example">[
  {`{"employee_id":"1001","passcode":"1234","last_name":"Graystone","first_name":"Andrew","role":"admin"}`}
]</pre>
        </div>
      </div>
    </div>
  );
}

export default App;
